import { CAN_UNDO_COMMAND, COMMAND_PRIORITY_LOW, UNDO_COMMAND } from "lexical";
import { useEffect, useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Undo2 } from "lucide-react";

export function UndoButton() {
    const [editor] = useLexicalComposerContext();
    const [canUndo, setCanUndo] = useState(false);

    useEffect(() => {
        return editor.registerCommand(
            CAN_UNDO_COMMAND,
            (payload) => {
                setCanUndo(payload);
                return false;
            },
            COMMAND_PRIORITY_LOW,
        );
    }, [editor]);

    return (
        <button
            type="button"
            className="rte-toolbar-button"
            disabled={!canUndo}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => editor.dispatchCommand(UNDO_COMMAND, undefined)}
            title="Undo"
            aria-label="Undo"
        >
            <Undo2 size={16} />
        </button>
    );
}
